// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.hit-the-floor {
  color: #fff;
  font-size: 12em;
  font-weight: bold;
  font-family: Helvetica;
  text-shadow: 
    0 1px 0 #ccc, 
    0 2px 0 #c9c9c9, 
    0 3px 0 #bbb, 
    0 4px 0 #b9b9b9, 
    0 5px 0 #aaa, 
    0 6px 1px rgba(0,0,0,.1), 
    0 0 5px rgba(0,0,0,.1), 
    0 1px 3px rgba(0,0,0,.3), 
    0 3px 5px rgba(0,0,0,.2), 
    0 5px 10px rgba(0,0,0,.25), 
    0 10px 10px rgba(0,0,0,.2), 
    0 20px 20px rgba(0,0,0,.15);
}

.hit-the-floor {
  text-align: center;
}
/* Form Module */
.form-module {
  background: #ffffff;
  max-width: 520px;
  width: 100%;
  border-top: 5px solid #33b5e5;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
  margin: 10% auto;
}

.form-module .form {
  display: none;
  padding: 40px;
}
.form-module .form:nth-child(2) {
  display: block;
}
.form-module h2 {
  margin: 0 0 20px;
  color: #33b5e5;
  font-size: 22px;
  text-align: center;
  font-weight: 400;
  line-height: 1;
}
.form-module input {
  outline: none;
  display: block;
  width: 100%;
  border: 1px solid #d9d9d9;
  margin: 0 0 20px;
  padding: 10px 15px;
  box-sizing: border-box;
  font-weight: 400;
  transition: 0.3s ease;
}
.form-module input:focus {
  border: 1px solid #33b5e5;
  color: #333333;
}
.form-module button {
  cursor: pointer;
  background: #33b5e5;
  width: 100%;
  border: 0;
  padding: 10px 15px;
  color: #ffffff;
  font-size: 15px;
  transition: 0.3s ease;
}
.form-module button:hover {
  background: #178ab4;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB;;;;;;;;;;;;+BAY6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;AACA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,6BAA6B;EAC7B,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.hit-the-floor {\n  color: #fff;\n  font-size: 12em;\n  font-weight: bold;\n  font-family: Helvetica;\n  text-shadow: \n    0 1px 0 #ccc, \n    0 2px 0 #c9c9c9, \n    0 3px 0 #bbb, \n    0 4px 0 #b9b9b9, \n    0 5px 0 #aaa, \n    0 6px 1px rgba(0,0,0,.1), \n    0 0 5px rgba(0,0,0,.1), \n    0 1px 3px rgba(0,0,0,.3), \n    0 3px 5px rgba(0,0,0,.2), \n    0 5px 10px rgba(0,0,0,.25), \n    0 10px 10px rgba(0,0,0,.2), \n    0 20px 20px rgba(0,0,0,.15);\n}\n\n.hit-the-floor {\n  text-align: center;\n}\n/* Form Module */\n.form-module {\n  background: #ffffff;\n  max-width: 520px;\n  width: 100%;\n  border-top: 5px solid #33b5e5;\n  box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);\n  margin: 10% auto;\n}\n\n.form-module .form {\n  display: none;\n  padding: 40px;\n}\n.form-module .form:nth-child(2) {\n  display: block;\n}\n.form-module h2 {\n  margin: 0 0 20px;\n  color: #33b5e5;\n  font-size: 22px;\n  text-align: center;\n  font-weight: 400;\n  line-height: 1;\n}\n.form-module input {\n  outline: none;\n  display: block;\n  width: 100%;\n  border: 1px solid #d9d9d9;\n  margin: 0 0 20px;\n  padding: 10px 15px;\n  box-sizing: border-box;\n  font-weight: 400;\n  transition: 0.3s ease;\n}\n.form-module input:focus {\n  border: 1px solid #33b5e5;\n  color: #333333;\n}\n.form-module button {\n  cursor: pointer;\n  background: #33b5e5;\n  width: 100%;\n  border: 0;\n  padding: 10px 15px;\n  color: #ffffff;\n  font-size: 15px;\n  transition: 0.3s ease;\n}\n.form-module button:hover {\n  background: #178ab4;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
